const bottomSheet = require('../components/bottomSheet');

/**
 * Checks whether the bottom sheet has an action for the currentStage
 * @param {string} currentStage The Current Checkout Stage
 * @returns {boolean} True if the bottom sheet has an action for the currentStage
 */
function isBottomSheetWithAction(currentStage) {
  const checkoutStageConstants = require('./stage/constants');
  const paymentInstruments = require('../paymentInstruments/paymentInstruments');

  const isCustomerStage = currentStage === checkoutStageConstants.CUSTOMER;
  const isShippingAddressStage =
    currentStage === checkoutStageConstants.SHIPPING_ADDRESS;
  const isOrderStage = currentStage === checkoutStageConstants.PLACE_ORDER;
  const shippingForm = document.querySelector('.shipping-form');
  const isShopDeliverySelected =
    shippingForm?.dataset.shopDeliverySelected === 'true';
  const isPaymentDetailsStage =
    currentStage === checkoutStageConstants.PAYMENT_DETAILS ||
    currentStage === checkoutStageConstants.SECOND_PAYMENT_DETAILS;

  return (
    !isCustomerStage &&
    !(isShippingAddressStage && isShopDeliverySelected) &&
    !(isOrderStage && paymentInstruments.methods.isPaypalSelected()) &&
    !(isOrderStage && paymentInstruments.methods.isApplePaySelected()) &&
    !(isPaymentDetailsStage && paymentInstruments.methods.isGooglePaySelected())
  );
}

module.exports = {
  initCheckoutBottomSheet() {
    bottomSheet.initialize({});
  },
  methods: {
    isBottomSheetWithAction,
  },
};
